<template>
    <div class="flex items-center gap-1">
        <simple-select
            :model-value="modelValue?.value ?? null"
            :options="durationOptions"
            :resettable="true"
            label-classes="flex justify-center items-center px-3"
            style="min-width: 50px"
            @update:model-value="onValueUpdated"
        />
        <simple-select :model-value="modelValue?.unit ?? null" :options="unitOptions" style="min-width: 110px" @update:model-value="onUnitUpdated" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import SimpleSelect from '@/Pages/Stakeholders/Maintainers/SimpleSelect.vue';

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    durationUnits: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits(['update:modelValue']);

const unitOptions = computed(() => props.durationUnits.map(({ label, value }) => ({ label, value })));

const valuesByUnit = computed(() => Object.fromEntries(props.durationUnits.map(({ value, durationValues }) => [value, durationValues])));

const durationOptions = computed(() => {
    const values = valuesByUnit.value[props.modelValue?.unit] ?? [];
    return values.map((value) => ({ label: value, value }));
});

const onUnitUpdated = (unit) => {
    const values = valuesByUnit.value[unit] ?? [];
    const current = props.modelValue?.value;
    const value = values.includes(current) ? current : null;
    emit('update:modelValue', { unit, value });
};

const onValueUpdated = (value) => {
    emit('update:modelValue', { unit: props.modelValue?.unit ?? null, value });
};
</script>
